/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import FormField, { CustomFormFieldProps } from './FormField'
import DateTimeInput, { DateTimeInputProps } from './DateTimeInput'

export type FormDateTimeFieldProps = CustomFormFieldProps<DateTimeInputProps>

function FormDateTimeField (props: FormDateTimeFieldProps) {
  const { name, ...others } = props
  return (
    <FormField
      {...others}
      name={name}
      render={DateTimeInput}
      suppressSeconds
      suppressMilliseconds
    />
  )
}

export default FormDateTimeField
